module.exports = __webpack_public_path__ + "static/navigator_gps-f58e77bbdd4d8686c30289e5278c98a8.png";